import { Link } from '@podiumhq/design-system';

import { PODIUM_APP_URL } from 'routes/constants';

import { TrialFieldError } from './FormFields/TrialFieldError';

const TrialAccountExistsMessage = ({ displayError, ...props }) => (
  <TrialFieldError displayError={displayError} fontSize="sm" {...props}>
    Looks like you already have an account{' '}
    <Link
      fontWeight="semibold"
      href={PODIUM_APP_URL}
      target="blank"
      textDecoration="underline"
    >
      Sign in
    </Link>
  </TrialFieldError>
);

export default TrialAccountExistsMessage;
